<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">
      <!-- Left illustration-->
      <b-col
        lg="8"
        class="d-none d-lg-flex align-items-center p-5 bg-light"
      >
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <b-img
            fluid
            :src="imgUrl"
            alt="Error page"
          />
        </div>
      </b-col>
      <!-- /Left illustration-->

      <!-- Content-->
      <b-col
        lg="4"
        class="d-flex align-items-center auth-bg px-2 p-lg-5 bg-white"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto text-center"
        >
          <b-img
            fluid
            src="@/assets/images/logo/logo.png"
            alt="logo"
            class="mb-2 logo-img"
          />
          <b-card-title
            class="mb-1 font-weight-bolder"
            title-tag="h3"
          >
            Página no encontrada
          </b-card-title>
          <b-card-text class="mb-2">
            La página que buscas no existe o ha sido movida.
          </b-card-text>

          <b-button
            variant="primary"
            block
            @click="goHome"
          >
            Volver al inicio
          </b-button>
        </b-col>
      </b-col>
      <!-- /Content-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { mapGetters } from 'vuex'
import store from '@/store/index'

export default {
  data() {
    return {
      downImg: require('@/assets/images/pages/error.svg'),
    }
  },
  computed: {
    ...mapGetters('auth', ['getUser', 'getHomeRoute']),
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.downImg = require('@/assets/images/pages/error-dark.svg')
        return this.downImg
      }
      return this.downImg
    },
  },
  methods: {
    goHome() {
      this.$router.push({ name: this.getUser ? this.getHomeRoute : 'login' })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';

.logo-img {
  max-width: 200px;
}
</style>
